import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { take } from 'rxjs';
import { OperatorModel } from '../../../shared/models/partial-cj/operator';
import { Utils } from '../../../shared/Utils/Utils';
import { PartialCjService } from '../../service/partial-cj.service';

@Component({
  selector: 'save-partail-details',
  templateUrl: './save-partail-details.component.html'
})
export class SavePartailDetailsComponent {
  public showModal = false;
  public operator = '';
  public telephone = '';
  public operatorModel: OperatorModel[];
  public isDataSaved = false;
  @ViewChild('partialInfoForm', { read: NgForm }) partialInfoForm: NgForm | undefined;

  @Output() Save: EventEmitter<any> = new EventEmitter<any>();
  constructor(private partialCJService: PartialCjService) {}
  public show() {
    this.openPcjPopUpOnClick();
    this.showModal = true;
  }

  public hide() {
    this.partialInfoForm?.resetForm();
    this.showModal = false;
  }

  public saveDetails() {
    if (this.partialInfoForm?.invalid) {
      return;
    }
    this.Save.emit({ operator: this.operator, telephone: this.telephone });
  }

  public openPcjPopUpOnClick = (): void => {
    this.partialCJService
      .getOperators()
      .pipe(take(1))
      .subscribe((value) => {
        this.showModal = true;
        this.operatorModel = value;
      });
  };

  onKeyPress(evt: any) {
    return Utils.isNumber(evt);
  }
}
